import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'

import { it, enGB, fr, de, es, nl, pl, Locale } from 'date-fns/locale'
import { useRouter } from 'next/router'

export const dateLocales: Record<string, Locale> = {
  it,
  en: enGB,
  fr,
  de,
  es,
  nl,
  pl,
}

export const supportedLanguages = [
  { text: '🇺🇸 EN', value: 'en' },
  { text: '🇮🇹 IT', value: 'it' },
  { text: '🇫🇷 FR', value: 'fr' },
  { text: '🇩🇪 DE', value: 'de' },
  { text: '🇪🇸 ES', value: 'es' },
  { text: '🇳🇱 NL', value: 'nl' },
  { text: '🇵🇱 PL', value: 'pl' },
]

type LanguageSwitcherProps = {
  supportedLocales?: string[]
}

export function LanguageSwitcher({ supportedLocales }: LanguageSwitcherProps = {}) {
  const router = useRouter()

  const languages = supportedLocales?.length
    ? supportedLanguages.filter(({ value }) => supportedLocales.includes(value))
    : supportedLanguages

  if (languages.length <= 1) {
    return null
  }

  const changeUserLanguage = (locale: string) => {
    const { pathname, asPath, query } = router
    router.push({ pathname, query }, asPath, { locale })
  }

  return (
    <div>
      <Select
        value={router.locale}
        onValueChange={(value) => changeUserLanguage(value)}
      >
        <SelectTrigger className="border-none shadow-none focus:ring-0 focus:ring-ring hover:bg-accent">
          <SelectValue placeholder="" />
        </SelectTrigger>
        <SelectContent>
          {languages.map(({ text, value }) => (
            <SelectItem value={value} key={value}>
              {text}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  )
}
